var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCroatiaCroatiaLoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.901 32.732h74.198c4.919 0 8.947 4.056 8.947 9.003v16.538c0 4.947-4.028 8.994-8.947 8.994H12.901c-4.919 0-8.947-4.047-8.947-8.994V41.736c0-4.947 4.018-9.003 8.947-9.003z",
    fill: "#fdc42e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.233 33.699h73.525c4.596 0 8.349 3.781 8.349 8.406v15.818c0 4.615-3.753 8.397-8.349 8.397H13.233c-4.587 0-8.349-3.781-8.349-8.397V42.105c0-4.625 3.762-8.406 8.349-8.406z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.076 34.58h61.877c-12.036 6.89-11.903 24.139.227 30.849H14.076c-4.151 0-7.553-3.421-7.553-7.591V42.181c.009-4.179 3.402-7.601 7.553-7.601z",
    fill: "#fdc42e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.01 39.973h4.132v15.979h6.814v3.62H12.01V39.973zm24.385 0v3.62h4.549v15.979h4.132V43.593h4.559v-3.62zm-6.757-.076c4.236 0 7.677 4.492 7.677 10.036S33.884 59.97 29.638 59.97s-7.677-4.492-7.677-10.036 3.44-10.036 7.677-10.036zm0 3.62c1.772 0 3.194 1.877 3.213 6.416s-1.441 6.416-3.213 6.416c-1.782 0-3.232-1.943-3.213-6.416s1.431-6.416 3.213-6.416zm26.84-3.62c4.236 0 7.677 4.492 7.677 10.036S60.724 59.97 56.478 59.97s-7.677-4.492-7.677-10.036 3.44-10.036 7.677-10.036zm0 3.62c1.772 0 3.194 1.877 3.213 6.416s-1.441 6.416-3.213 6.416c-1.782 0-3.232-1.943-3.213-6.416s1.431-6.416 3.213-6.416z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.788 40.02c2.739-.057 3.819 1.412 3.819 4.094s-1.914 4.198-4.161 4.104c-3.488-.152-4.578-3.004-3.725-6.985.692-3.222 3.867-6.644 3.867-6.644h3.099c-.009-.009-3.327 4.066-2.9 5.43zm-.265 1.772c.73 0 1.327.843 1.327 1.905 0 1.052-.597 1.905-1.327 1.905-.72 0-1.317-.843-1.317-1.905s.588-1.905 1.317-1.905zm-3.118 16.13 1.602.057 13.391-17.704-1.602-.038zm9.913-5.241h-2.644l-4.549 6.814-.009 2.275h4.549v2.73h2.644v-2.729h.881v-2.275h-.881v-6.814zm-4.852 6.814 2.208-3.308v3.308h-2.208zm6.113-6.738v6.606h2.407c2.549.341 1.772 4.985-2.701 2.673l.019 2.331c2.625 1.497 7.136.199 7.26-3.298.104-2.957-2.113-3.819-4.587-3.829v-1.829h4.018v-2.654h-6.416z",
    fill: "#fdc42e"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M-42 68z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCroatiaCroatiaLoto);
export default __webpack_public_path__ + "static/media/croatia_croatia_loto.11b791bfbe2fddc128b473bb8d3c6a77.svg";
export { ForwardRef as ReactComponent };